var html = document.documentElement;
var isMacLike = !!navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
if (isMacLike) {
    html.classList.add('isMac');
}

// Check with brower safari
if (navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1) {
    html.classList.add("isSafari");
}


// FAQ blog 
$('.faqs .faqs__question h3').parents('.faqs__item').addClass('active-bottom');

$('.faqs .faqs__question h3').parents('.page-column-grid').addClass('header-question');

// Color swatch
$('.color-swatch').on("click", function () {
    $(this).parents('.group-color-swatch').toggleClass("active");
})

// Anchor link email
$(document).ready(function(){
    function scrollToDiv(divId) {
        var target = $('#' + divId);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + 30
            }, 1000);  
        }
    }

    var currentPath = window.location.pathname; 
    var currentHash = window.location.hash;   

    if (currentPath === 'https://marketlane.com.au/pages/coffee' && currentHash) {
        var divId = currentHash.substring(1); 
        scrollToDiv(divId);
    }

    // Handle anchor page coffee
     for (var i = 1; i <= 10; i++) {
        let anchorClass = '.anchor_' + i;
        
        $(anchorClass).on('click', function() {
            $("a").removeAttr("href");
            $('html, body').animate({
                scrollTop: $(this).offset().top
            }, 'slow');
        });
    }
});

// Product recommendation custom
// $(document).ready(function() {
//     var windowsize = $(window).width();
//     if (windowsize > 767) {
//         // get card width dynamically
//         cardWidth = $(".product-related-custom .product__item").width();
//         // next-arrow
//         $('#next-arrow').click(function(e) {
//             e.preventDefault();
//             var firstChildAppend = $(".product-related-custom .product__item:first-child()");
//             $(".product-related-custom .product__item").animate({
//                 left: -cardWidth
//             }, function() {
//                 $('.featured-product__content').append(firstChildAppend);
//                 $(".product-related-custom .product__item").css({
//                     left: 0,
//                 })
//             })
//         });
//         // previous-arrow
//         $('#previous-arrow').click(function(e) {
//             e.preventDefault();
//             var lastChildPrepend = $(".product__item:last-child()");
//             $(".product-related-custom .product__item").animate({
//                 left: cardWidth
//             }, function() {
//                 $('.product-related-custom .featured-product__content').prepend(lastChildPrepend);
//                 $(".product-related-custom .product__item").css({
//                     left: 0,
//                 })
//             })
//         });
//     }

// });


// Shopping cart note
var maxchars = 100;

$('body').on('keyup paste', '.cart-note__input', function() {
    // Validate max 100 characters
    var tlength = $(this).val().length;
    // console.log("Test data", tlength);
    if (tlength > maxchars) {
        $('.cart-note .errors_character').css("display", "block");
        $('.cart-note .errors_character').text("Instructions must be 100 characters or less.");
        // $(this).val($(this).val().substring(0, maxchars));
    } else {
        $('.cart-note .errors_character').css("display", "none");
        $('.cart-note .errors_character').text("");
    }

    // Validate emoiji
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}]/u;
    const containsEmoji = (text) => emojiRegex.test(text);
    const textareaValue = $(this).val();

    if (containsEmoji(textareaValue) == true) {
        $('.cart-note .errors_emoji').css("display", "block");
        $('.cart-note .errors_emoji').text("Instructions can only contain alphabetical and numerical characters, please edit.");

    } else {
        $('.cart-note .errors_emoji').css("display", "none");
        $('.cart-note .errors_emoji').text("");
    }

});


// Subscription custom three popup
// Popup custom 1
$('.list-item.popup_1').on("click",function(){
    // hide the other two popups
    $(this).parents(".list-popup-item-1").siblings(".list-popup-item-2").removeClass("active-popup2");
    $(this).parents(".list-popup-item-1").siblings(".list-popup-item-3").removeClass("active-popup3");
})

// Popup custom 2
$('.list-item.popup_2').on("click",function(){
     // hide the other two popups
    $(this).parents(".list-popup-item-2").siblings(".list-popup-item-1").removeClass("active-popup1");
    $(this).parents(".list-popup-item-2").siblings(".list-popup-item-3").removeClass("active-popup3");
})

// Popup custom 3
$('.list-item.popup_3').on("click",function(){
    // hide the other two popups
    $(this).parents(".list-popup-item-3").siblings(".list-popup-item-1").removeClass("active-popup1");
    $(this).parents(".list-popup-item-3").siblings(".list-popup-item-2").removeClass("active-popup2");
})

// Handle click popup
for(let i=1; i<=3; i++){
    // Handle value default label when change on step 3 personal
     if ($('.subscription.personal-subscription').length == 1) {
        let grind_type= $(`.subscription-step__label-text_custom_${i} span.person_value:first-child`).text();
        $(`.subscription-step__label-text_custom_${i}`).attr('data-grind', grind_type );
     }
    $(`.list-item.popup_${i}`).on("click",function(){
        // Handle trigger fist step on personal page
         if ($('.subscription.personal-subscription').length == 1) {
            // auto trigger step 2 week
            $(`.subscription-step__content_custom_${i} div>a:first-child`).trigger('click');
            $(`.subscription-step-dropdown_custom_${i}`).hide();
         }

        // Trigger first step choose subscription length
        $(`.option-select_custom_${i} a:first-child`).trigger("click");

        // Active popup
        $(this).parents(`.list-popup-item-${i}`).addClass(`active-popup${i}`);

        // Gift subscription date
        $(`.popup_${i} .js-shipment-dropdown-item:first-child`).trigger("click");
        $(`.popup_${i} .shipment-dropdown`).hide();

        // Scroll to div
        if($(window).width() > 1023) {
            $('html, body').animate({
                scrollTop: $(".subscription__desc").offset().top
            }, 1000);
        }else {
            $('html, body').animate({
                scrollTop: $(`.list-popup-item-${i}`).offset().top
            }, 1000);
        }
    })
}

// Handle close popup
for(let i=1; i <= 3; i++){
    $(`.popup_${i} .close-popup`).on("click",function(){
        $(this).parents(`.list-popup-item-${i}`).removeClass(`active-popup${i}`)
    })
}


// Hide popup when click outside
$(document).on("click",function(e){
    if(!$(e.target).closest('.main-popup').length){
        for(let i=1; i <=3; i++){
             $('.main-popup').removeClass(`active-popup${i}`);
        }
    }
})

// Anchor popup
$(".page-subscription-personal-v2 .coffee-club__actions .btn-subscriber").on("click", function(e){
    e.preventDefault();
     $('html, body').animate({ 
        scrollTop:$('.subscription-custom').offset().top
    },'slow');
})

// Gift subscription page new v2
$(document).on("ready",function(){
    $('.gift-subscription .btn-recipient').on("click", function(){
        $(this).parents(".main-popup").addClass("active-recipient");
    });

    $('.popup-recipient-details .close-popup, .popup-recipient-details .btn-back-popup').on("click", function(){
        $(this).parents(".main-popup").removeClass("active-recipient");
    })
});

// Reset form input when back to page
if ($('.subscription.gift-subscription').length == 1) {
    window.addEventListener("pageshow", () => {
        var form = $('.gift-subscription__form'); 
        if(form.length){
            form[0].reset();
        }
    });
}
// Shopping cart note
var maxchars = 100;

$('body').on('keyup paste', '.cart-note__input', function() {
    // Validate max 100 characters
    var tlength = $(this).val().length;
    // console.log("Test data", tlength);
    if (tlength > maxchars) {
        $('.cart-note .errors_character').css("display", "block");
        $('.cart-note .errors_character').text("Instructions must be 100 characters or less.");
        // $(this).val($(this).val().substring(0, maxchars));
    } else {
        $('.cart-note .errors_character').css("display", "none");
        $('.cart-note .errors_character').text("");
    }

    // Validate emoiji
    const emojiRegex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/u;
    const containsEmoji = (text) => emojiRegex.test(text);
    const textareaValue = $(this).val();

    if (containsEmoji(textareaValue) == true) {
        $('.cart-note .errors_emoji').css("display", "block");
        $('.cart-note .errors_emoji').text("Instructions can only contain alphabetical and numerical characters, please edit.");

    } else {
        $('.cart-note .errors_emoji').css("display", "none");
        $('.cart-note .errors_emoji').text("");
    }

    // Validate break line
    const hasBreakLine = /\r|\n/.test(textareaValue);
    if (hasBreakLine) {
        $(this).val($(this).val().replace(/[\r\n\v]+/g, ''));
    } 

});

// Article page new 
$(document).on("ready", function(){
    $('.banner-image-full-width').parents("body").addClass("has-image-fullwidth");
    if ($('.article .brew-details__content p').length === 0) {
        $("body.article .article").addClass("no-content");
    }

    // CMS page
    if ($('.article .brew-details__content').length === 0) {
        $(".template-page .article").addClass("no-content");
    }

    $('.cms-image-fullwidth').parents("body").addClass("cms-has-image-fullwidth");
});


// Decaf PDP
$(document).on("ready", function(){
    $('.product-detail-tabs__item-subscription .product-detail-tabs__header').on("click", function(){
        $(this).parents('.product-detail-tabs__item-subscription').toggleClass("active");
    })
})


// Hidden ongoing subscription products on You may also like - Recharge Customer Portal
setInterval(function(){
    const keywords = ['subscription', 'ongoing'];
    $('#recharge-customer-portal article div').filter(function() {
        const text = $(this).text().toLowerCase();
        return keywords.some(word => text.includes(word));
    }).each(function() {
        $(this).closest('div').remove();
    });

    // Hidden ongoing subscription in browser product
    const keywords1 = ['subscription', 'ongoing'];

    if ($('.recharge-heading').filter(function() {
        return /add items/i.test($(this).text());
    }).length) {
        $('.recharge-theme').addClass('has-add-items');
        $('.recharge-theme div[data-ismodal="true"] div').filter(function() {
            const text1 = $(this).text().toLowerCase();
            return keywords1.some(word1 => text1.includes(word1));
        }).each(function() {
            // $(this).closest('div.recharge-component-product-item').parent('div').addClass("hidden-product-subscription");
            $(this).closest('div.recharge-component-product-item').parent('div').remove();

        });
    }


}, 1000)
